import reducer from './reducers';
import { routes } from '../routes';
import * as authOperations from './operations';
import * as authActions from './actions';

export {
    authOperations,
    authActions
};

export default {
    routes,
    reducer
}
